import { Component } from '@angular/core';
import { ICustomerInquiryModel } from '../property-detail/property.modal';
import { ApiService } from '../api.services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent {

  isContactSubmitted:boolean = false;
  isAgreeTermServiceCheck: boolean = false;
  inquiryData: ICustomerInquiryModel = {
    customerDetails:{
      customerId: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNo: ''
    },
    propertyDetails: {
      inquiryId: '',
      propertyId: '',
      inquiryCode: '',
      inquiryType: 'External',
      inquiryDetail: '',
      metaFormName:''
    }
  }; 

  constructor(
    private _apiService : ApiService
    ){
      
    }
    
  savePropertyInquiry(): void {
    // Close the dialog and pass data back to the parent
    this._apiService.savePropertyInquiry(this.inquiryData).subscribe((res: any) => {
      this.isContactSubmitted = true;
      this.inquiryData = {
        customerDetails:{
          customerId: '',
          firstName: '',
          lastName: '',
          email: '',
          phoneNo: ''
        },
        propertyDetails: {
          inquiryId: '',
          propertyId: '',
          inquiryCode: '',
          inquiryType: 'External',
          inquiryDetail: '',
          metaFormName:''
        }
      }; 
    });
  }

  isContactFormValid(): boolean{
    return (this.isAgreeTermServiceCheck && this.inquiryData.customerDetails.firstName != ''
      && this.inquiryData.customerDetails.phoneNo != ''
    )
  }
}
